import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router';

import { ANY_BARBER } from '../constants';

const WithAnyBarber = compose(
  withRouter,
  withProps(props => ({
    anyBarber: props.params.barberRoute === ANY_BARBER,
  })),
);

export default WithAnyBarber;



// WEBPACK FOOTER //
// ./src/app/hoc/WithAnyBarber.js